export default function SelectedSeatsService(
) {
    'ngInject';

    Object.assign(this, {
        selectSeat,
        deselectSeat,
        deselectAllForTraveller,
        selectSeatFFN,
        getSelectedFFN,
        isSeatSelectedForTraveller,
        isSeatSelected,
        isSeatOrFfnSelectedForTraveller,
        getSelectionModel,
        hasUserSelectedSeatForFlightRecommendation,
        isFfnUsedForSeatSelection,
    });

    function selectSeat(selectedSeats, traveller, flight, seat, selectedPassengerId, seatCharacteristic) {
        const areArgsValid = selectedSeats
            && traveller && traveller.Id
            && flight && flight.Id
            && seat && seat.name;

        if (!areArgsValid) {
            return selectedSeats;
        }

        const {Id: flightId} = flight;
        const {Id: travellerId} = traveller;

        if (!selectedSeats[flightId][travellerId]) {
            selectedSeats[flightId][travellerId] = {};
        }

        selectedSeats[flightId][travellerId].SeatNumber = seat.name;

        const priceData = seat.getPrice(selectedPassengerId);
        const price = priceData && parseFloat(priceData.total);

        selectedSeats[flightId][travellerId].SeatPrice = price;

        const descriptions = Array.from(seat.characteristicList.values()).map((characteristic) => _.find(seatCharacteristic, (mapItem) => mapItem[0] === characteristic)[1]);
        selectedSeats[flightId][travellerId].SeatPosition = descriptions.join(', ');

        return selectedSeats;
    }

    function deselectAllForTraveller(selectedSeats, traveller) {
        const travellerId = traveller.Id;

        Object.keys(selectedSeats).forEach((flightId) => {
            if (selectedSeats[flightId][travellerId]) {
                selectedSeats[flightId][travellerId] = {
                    SeatNumber: null,
                    SeatPrice: null,
                    SeatPosition: null,
                    TravellerClubCardId: null,
                };
            }
        });

        return selectedSeats;
    }

    function deselectSeat(selectedSeats, traveller, flight) {
        const areArgsValid = selectedSeats
            && traveller && traveller.Id
            && flight && flight.Id;

        if (!areArgsValid) {
            return selectedSeats;
        }

        const {Id: flightId} = flight;
        const {Id: travellerId} = traveller;

        if (!selectedSeats[flightId][travellerId]) {
            selectedSeats[flightId][travellerId] = {};
        }

        selectedSeats[flightId][travellerId].SeatNumber = null;
        selectedSeats[flightId][travellerId].SeatPrice = null;
        selectedSeats[flightId][travellerId].SeatPosition = null;

        return selectedSeats;
    }

    function selectSeatFFN(ffnOption, selectedSeats, flight, traveller) {
        if (!selectedSeats[flight.Id]) {
            selectedSeats[flight.Id] = {};
        }
        if (!selectedSeats[flight.Id][traveller.Id]) {
            selectedSeats[flight.Id][traveller.Id] = {};
        }
        const ffn = ffnOption ? ffnOption : {};
        if (!ffn.value) {
            ffn.raw = {};
        }
        const {value, raw: {Id, SupplierCode, SupplierName}} = ffn;
        const selectedSeat = selectedSeats[flight.Id][traveller.Id];
        selectedSeats[flight.Id][traveller.Id] = {
            ...selectedSeat,
            TravellerClubCardId: Id,
            Ffn: value,
            SupplierCode,
            SupplierName,
        };

        return selectedSeats;
    }

    function getSelectedFFN(traveller, flight, selectedSeats) {
        return selectedSeats
            && selectedSeats[flight.Id]
            && selectedSeats[flight.Id][traveller.Id]
            && selectedSeats[flight.Id][traveller.Id].TravellerClubCardId
            || null;
    }

    function isSeatSelectedForTraveller(selectedSeat) {
        return !!selectedSeat
            && !!selectedSeat.SeatNumber
            && selectedSeat.SeatNumber.length > 0;
    }

    function isFfnSelectedForTraveller(selectedSeat) {
        return !!selectedSeat
            && !!selectedSeat.TravellerClubCardId;
    }

    function isSeatSelected(traveller, flight, selectedSeats) {
        const selectedSeat = selectedSeats
            && selectedSeats[flight.Id]
            && selectedSeats[flight.Id][traveller.Id]
            || null;
        return isSeatSelectedForTraveller(selectedSeat);
    }

    function isSeatOrFfnSelectedForTraveller(traveller, selectedSeats) {
        return Object.values(selectedSeats).some((travellers) => {
            const selectionModel = travellers[traveller.Id];
            return !!selectionModel
                && (isFfnSelectedForTraveller(selectionModel) || isSeatSelectedForTraveller(selectionModel));
        });
    }

    function getSelectionModel(traveller, flight, selectedSeats) {
        return traveller && traveller.Id
            && flight && flight.Id
            && selectedSeats
            && selectedSeats[flight.Id]
            && selectedSeats[flight.Id][traveller.Id]
            || null;
    }

    function hasUserSelectedSeatForFlightRecommendation(flightRecommendation, selectedSeats) {
        if (!selectedSeats) {
            return false;
        }

        return flightRecommendation.FlightGroups
            .reduce(extractAllFlights, [])
            .map((flight) => flight.Id)
            .filter((flightId) => !!selectedSeats[flightId])
            .reduce(extractAllSelectionModels, [])
            .some(isSeatSelectedForTraveller);

        function extractAllFlights(flightGroupsAcc, flightGroup) {
            return [
                ...flightGroupsAcc,
                ...flightGroup.Flights.reduce((flightsAcc, flight) => [
                    ...flightsAcc,
                    flight,
                ], []),
            ];
        }

        function extractAllSelectionModels(accumulator, flightId) {
            return [
                ...accumulator,
                ...Object.values(selectedSeats[flightId]),
            ];
        }
    }

    function isFfnUsedForSeatSelection(clubCard, selectedSeats) {
        return Object.values(selectedSeats).some((travellers) =>
            Object.values(travellers).some((selectionModel) =>
                selectionModel.SupplierCode === clubCard.SupplierCode && selectionModel.Ffn === clubCard.Ffn));
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/flights/flight-seatmap/selected-seats-service.js